// extracted by css-extract-rspack-plugin
export default {"panel":"eagS5R5nSs465mb4","logo":"X1Ac66HTsM4ji3eA","heading":"YIIVtfaQ5eAYmgTb","copy":"WZuu43zL_xohfPAQ"};